<template>
  <v-navigation-drawer v-model="showSidebar" app width="280">
    <v-toolbar absolute style="padding:10px" height="80" width="279" color="primary">
      <div style="position:absolute;transform:translate(-10px,-10px)">
        <v-btn text fab x-small @click="showSidebar = false">
          <v-icon color="white" style="transform:translateX(1px)">mdi-menu-left</v-icon>
          <v-icon color="white" style="transform:translateX(-7px)">mdi-menu</v-icon>
        </v-btn>
      </div>
      <div class="sodalogo white--text">
        <v-img
          contain
          height="60px"
          width="120px"
          :src="require('@/assets/soda_logo_white.png')"
          style="position:absolute;transform:translate(55px,-40px);cursor:pointer"
          @click="onLogoClick()"
        />
      </div>
      <!--
            <div class="sodalogo">
                <div class="display-1 ml-12 white--text font-weight-medium">SOD</div>
                <div>
                    <v-icon large class="sodaicon" color="accent">send</v-icon>
                </div>
                <div class="sodabetatag white--text">beta</div>
            </div>
            -->
      <div style="position:absolute;transform:translateX(120px)">
        <SyncStatusIndicator />
      </div>
    </v-toolbar>
    <v-toolbar height="80" width="280" flat></v-toolbar>
    <v-divider></v-divider>
    <div v-if="companies">
      <v-list dense nav>
        <v-slide-y-transition group>
          <template v-for="item in companies">
            <v-list-item v-on:click="selectedCompany = item" :to="{ path: '/app/company/' + item.id }" :key="item.id">
              <v-list-item-avatar tile class="mr-1" height="25">
                <v-icon>business</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>{{ item.name }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="selectedCompany === item"
              :to="{ path: '/app/company/' + item.id + '/processes' }"
              :key="item.id + '-proc'"
            >
              <v-list-item-avatar tile class="mr-1 ml-4" height="25">
                <v-icon>subject</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Verfahren</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="selectedCompany === item"
              :to="{ path: '/app/company/' + item.id + '/measures' }"
              :key="item.id + '-mset'"
            >
              <v-list-item-avatar tile class="mr-1 ml-4" height="25">
                <v-icon>list</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Allgemeine TOMs</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              v-if="selectedCompany === item"
              :to="{ path: '/app/company/' + item.id + '/documents' }"
              :key="item.id + '-docs'"
            >
              <v-list-item-avatar tile class="mr-1 ml-4" height="25">
                <v-icon>folder</v-icon>
              </v-list-item-avatar>
              <v-list-item-content>
                <v-list-item-title>Dokumente</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-slide-y-transition>
      </v-list>
    </div>
    <v-spacer></v-spacer>
    <div class="text-center">
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-btn outlined v-on="on" v-on:click="onCreateNewCompany()" color="primary">
            Neues Unternehmen
          </v-btn>
        </template>
        <span>Legen Sie ein neues Unternehmen an, für das Sie ein Verfahrensverzeichnis pflegen möchten.</span>
      </v-tooltip>
    </div>
    <v-list dense nav>
      <v-list-item to="/app/account">
        <v-list-item-avatar tile class="mr-1" height="25">
          <v-icon>account_circle</v-icon>
        </v-list-item-avatar>
        <v-list-item-title>Profil</v-list-item-title>
      </v-list-item>
    </v-list>
    <CompanyCreateView :showThis="show_company_create_view" v-on:discard="show_company_create_view = false">
    </CompanyCreateView>
  </v-navigation-drawer>
</template>

<script>
import CompanyCreateView from "./CompanyCreateView";
import SyncStatusIndicator from "./SyncStatusIndicator";

const plans_specs = require("json-loader!yaml-loader!../specs/plans.yml");
function arrayToObject(arr, key) {
  var rv = {};
  for (var i = 0; i < arr.length; ++i) rv[arr[i][key]] = arr[i];
  return rv;
}
const products = arrayToObject(plans_specs.products, "id");

const listCompanys = `query ListCompanys(
  $nextToken: String
) {
  listCompanys (limit: 50, nextToken: $nextToken){
    items {
      id
      name
    }
    nextToken
  }
}
`;

export default {
  name: "SidebarView",
  data: () => ({
    companies: [],
    show_company_create_view: false,
  }),
  components: {
    CompanyCreateView,
    SyncStatusIndicator,
  },
  computed: {
    selectedCompany: {
      get() {
        return this.$store.state.originalStore.selectedCompany;
      },
      set(value) {
        this.$store.commit("SET_selectedCompany", value);
      },
    },
    listCompanysQuery() {
      return this.$Amplify.graphqlOperation(listCompanys);
    },
    showSidebar: {
      get() {
        return this.$store.state.originalStore.sidebarVisible;
      },
      set(value) {
        this.$store.commit("SET_sidebarVisible", value);
      },
    },
  },
  mounted() {
    this.updateCompanies();
    this.$store.dispatch("getCompanies");
  },
  methods: {
    onLogoClick(e) {
      this.$router.push({ path: "/home" });
    },
    updateCompanies(selectedCompany, nextToken) {
      if(nextToken === undefined){
        this.companies = []
      }
      this.$Amplify.API.graphql(this.$Amplify.graphqlOperation(listCompanys, {nextToken}))
        .then((res) => {
          let new_nextToken = res.data.listCompanys.nextToken;
          Array.prototype.push.apply(this.companies, res.data.listCompanys.items)
          if (new_nextToken !== null){
            this.updateCompanies(selectedCompany, new_nextToken)
            return
          }          this.companies.sort((a, b) => (a.name > b.name ? 1 : -1));
          if (selectedCompany) {
            for (var company of this.companies) {
              if (company.id === selectedCompany.id) {
                this.selectedCompany = company;
              }
            }
          }
          if (this.companies.length === 1) {
            this.selectedCompany = this.companies[0];
          }
        })
        .catch((err) => {
          console.error("error in listCompanys query", err);
        });
    },
    can_create_company() {
      var product_id = this.$store.state.originalStore.user_info.attributes["custom:active_product_id"];
      var product = products[product_id];
      var num_companies = this.companies.length;
      return num_companies < product.usage.max_companies;
    },
    onCreateNewCompany() {
      if (this.can_create_company()) {
        //this.$router.push({ path: '/app/company/new' })
        this.show_company_create_view = true;
      } else {
        this.$eventHub.emit("show-company-create-disallowed");
      }
    },
    onImportFromFile() {
      this.$router.push({ path: "/upload" });
    },
    onCreateFromTemplate(tpl_name) {
      this.$router.push({ path: "/template/" + tpl_name });
    },
    toggleSidebar() {
      console.log("toggleSidebar", this.showSidebar, ">", !this.showSidebar);
      this.showSidebar = !this.showSidebar;
    },
  },
  created() {
    this.$eventHub.on("company-updated", (msg) => this.updateCompanies());
    this.$eventHub.on("company-created", (msg) => {
      this.updateCompanies(msg);
    });
    this.$eventHub.on("company-deleted", (msg) => this.updateCompanies());
  },
};
</script>

<style lang="scss" scoped>
/*.sodalogo {
    transform: translate(10pt,16pt);
    pointer-events: none;
}*/
.sodaicon {
  transform: translate(85pt, -33pt) rotate(-75deg);
}
.sodabetatag {
  transform: translate(69pt, -24pt) rotate(82deg);
}
</style>
